import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
const _base = "zxCourseSchedule/";

// 排课信息 - 列表
export const courseScheduleMyPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "myPage", {
    data: _params,
    method: "GET",
  });
};
// 排课信息 - 根据日期获取课表
export const courseScheduleDatePage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "dateStr", {
    data: _params,
    method: "GET",
  });
};


// WEBPACK FOOTER //
// ./src/fetch/api/courseSchedule.js